<template>
  <div class="text-center">
    <img alt="Logo Jaleko 360" src="@/assets/img/logo-jaleko.svg" class="mb-4 img-fluid">
    <h1>Agendas</h1>
    
    <social/>

    <div class="ou text-center">
      <hr />
      <p>ou</p>
    </div>

    <user-and-password ref="userAndPassord"/>

    <forgot-password/>

    <social-create-user></social-create-user>

    <button class="btn btn-secondary mt-4" @click='login'>Fazer login</button>

    <p class="d-block mt-4">Ainda não é cadastrado? <a @click="goToRegister" class="btn-link">Cadastre-se</a></p>
  </div>
</template>

<script>
import './style.scss'
import UserAndPassword from './userAndPassword.vue'
import ForgotPassword from './forgotPassword.vue'
import SocialCreateUser from './socialCreateUser.vue'
import Social from './social.vue'

export default {
  name: 'LoginOptions',
  components: { UserAndPassword, ForgotPassword, Social, SocialCreateUser },
  methods: {
    async login () {
      this.$refs.userAndPassord.$v.$touch()

      if (!this.$refs.userAndPassord.$v.$invalid) {
        let loader = this.$loading.show()
        await this.$store.dispatch('login')
        loader.hide()
      }
    },
    goToRegister () {
      window.location = process.env.VUE_APP_URL + '/cadastro'
    }  
  }
}
</script>